import { browserHistory } from 'utils/navigation'
import { setSubroute } from 'store/navbar'
import { injectReducer } from 'store/reducers'
import { UserIsAuthenticated, UserHasValidPassword } from 'containers/authContainers'
import { actions as notyActions } from 'layouts/ErrorBox'
import { setPageTitle } from 'utils/misc'
import { isSameUser } from 'utils/userUtils'
import { getInvalidSessionMessage } from 'utils/sessionUtils'
import { generateNotyMessage } from 'utils/request'
import reducer, {
  actions as createUserActions,
} from '../Studies/routes/Study/routes/Users/routes/CreateUser/modules/CreateUser'
import UserView from '../Studies/routes/Study/routes/Users/routes/CreateUser/containers/UserContainer'
import { fetchStudies } from '../Studies/StudiesPage/modules/Studies'

export const loadMyProfilePage = store => {
  const { user, studies } = store.getState()
  setPageTitle('My Profile | Admin Panel')
  store.dispatch(setSubroute('me'))

  const sessionMessage = getInvalidSessionMessage(user)
  if (sessionMessage) {
    store.dispatch(
      notyActions.showError({
        text: generateNotyMessage(sessionMessage, false),
        killer: true,
      }),
    )
    return
  }

  if (studies.length === 0) store.dispatch(fetchStudies())
  store.dispatch(createUserActions.resetUserPage())
  store.dispatch(createUserActions.fetchUser('me'))
}

// Sync route definition
export default store => ({
  path: '/users/me',
  getComponent(nextState, cb) {
    const { user } = store.getState()
    if (isSameUser(user.id) ?? true) {
      require.ensure(
        [],
        () => {
          injectReducer(store, {
            key: 'userReducer',
            reducer,
          })
          loadMyProfilePage(store)
          /*  Return getComponent   */
          cb(null, UserIsAuthenticated(UserHasValidPassword(UserView)))
        },
        '/users/me',
      )
    } else browserHistory.push('/')
  },
})
